import CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import { LayoutInterval } from '../interfaces/LayoutInterval';
import { SurfaceItem } from '../interfaces/SurfaceItem';

/**
 * Creates a surface item to represent the given interval.
 * @param key A key that identifies this surface item, to be given to React elements created from this item.
 * @param model The model that will be represented by the SurfaceItem.
 * @returns A surface item, which can be manipulated as a LayoutInterval.
 */
export function createSurfaceItem(
    interval: LayoutInterval,
    key: string,
    model: CalendarEvent
): SurfaceItem {
    return {
        start: interval.start,
        end: interval.end,
        clippedLeft: interval.clippedLeft,
        clippedRight: interval.clippedRight,
        key,
        model,
    };
}
